// @flow

import { type Receipt } from '@tectonics/prs/receipts';
import { type TransactionFeeCode, type TransactionFee } from '@tectonics/prs/money';

export function getTransactionFees(receipt: Receipt, transactionFeeCode: ?TransactionFeeCode): ?TransactionFee {
  if (!receipt.transaction_fees) {
    return null;
  }

  return receipt.transaction_fees.find(fee => fee.code === transactionFeeCode);
}
